/* eslint-disable no-use-before-define */
import './modal.css'
import React from 'react'
import { Navigation } from './navigation'
import { Header } from './header'
import { CusipInput } from './cusip-input'
import { BondDetails } from './bond-details'
import { CalcInput } from './calc-input'
import { CalcOutput } from './calc-output'
import { ContextProvider, useCalculator, STEPS } from './use-calculator'
import { Loading, Status, } from '../twd'
import { NextStep } from './next-step'
import { CalcCoupons } from './calc-coupons'
import { Footer } from './footer'
import { CantCalc } from './cant-calc'

export default (args) => {

    return <React.Fragment>
    <div
        data-name="calculator-modal"
        className="modal-dialog modal-lg calculator-modal"
    >
    <div className="modal-content">
    <ContextProvider {...args}>
        <Navigation />
        <Header />
        <div className='container calculator-form'>
        <Init />
        <CusipInput />
        <CusipStatus />
        <BondDetails />
        <CalcInput />
        <CalcStatus />
        <CalcOutput />
        <CalcCoupons />
        <CantCalc />
        <NextStep />
        <Footer />
        </div>
    </ContextProvider>

    </div>
    </div>
    </React.Fragment>
}

const Init = () => {
    const { step } = useCalculator()

    return step===STEPS.INIT || step===STEPS.INIT_LOADING ? <Loading status={Status.LOADING} /> :
        step===STEPS.INIT_ERROR ? <Loading status={Status.FAILED_TO_LOAD} /> :
        null
}

const CusipStatus = () => {
    const { step } = useCalculator()

    return step===STEPS.CUSIP_LOADING ? <Loading status={Status.LOADING} /> :
        step===STEPS.CUSIP_ERROR ? <Loading status={Status.FAILED_TO_LOAD} /> :
        null
}

const CalcStatus = () => {
    const { step } = useCalculator()
    return step===STEPS.CALC_LOADING ? <Loading status={Status.LOADING} /> :
        step===STEPS.CALC_ERROR ? <Loading status={Status.FAILED_TO_LOAD} /> :
        null
}
